import { useStatusOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useQueryParams } from '@fs/zion-router'
import { useCallback } from 'react'
import { useOverlayContext } from '../../shared/providers/overlayContextProvider/OverlayContext'
import useNamesExperienceOptIn from './useNamesExperienceOptIn'

export default function useStatusOverlayTrigger() {
  const showStatusOverlay = useStatusOverlay()
  const [t] = useTranslation()
  const { query } = useQueryParams()
  const { openOverlay } = useOverlayContext()
  const { isOptedIn } = useNamesExperienceOptIn()

  const triggerStatusOverlay = useCallback(
    (isSuccess = false) => {
      // Only show success overlays in fullText view
      if (query.view !== 'fullText') return

      if (isSuccess) {
        // Only show attach prompt when the user is in the updated Names experience
        if (isOptedIn) {
          showStatusOverlay({
            message: t('full-text.image.downloaded', 'Image Downloaded. Want to attach this image to the Tree?'),
            type: 'success',
            dismissable: true,
            actionLabel: t('full-text.attach', 'Attach'),
            actionCallback: () => {
              // FSS-14672: attach-to-tree always goes straight to the classic 4-step flow
              openOverlay('mainInfosheet')
              openOverlay('attachToTreeOverlay')
            },
          })
        } else {
          // Show success without attach option for users not in the updated Names experience
          showStatusOverlay({
            message: t('full-text.image.downloaded', 'Image Downloaded'),
            type: 'success',
            dismissable: true,
          })
        }
      } else {
        // Still show error overlays regardless of view
        showStatusOverlay({
          message: t('full-text.failed-download', 'Error downloading the file'),
          type: 'error',
        })
      }
    },
    [showStatusOverlay, t, query.view, isOptedIn, openOverlay]
  )

  return { triggerStatusOverlay }
}
